'use strict' ;
angular.module("Khayrokom").service("callService" , [
	'$http' , 'baseURL' ,'$cookies','Notification','$filter','$q',
    function($http , baseURL , $cookies, Notification,$filter,$q){
          this.ajaxCall = function(request){
          	var headers = {};
          	if (request.auth===undefined||request.auth) {
                    try {
                    	  headers['lang'] = $cookies.get('lang');
                    } catch (e) {

                    }
                }
          	if (request.isJson===undefined||request.isJson) {
                    headers['Content-type'] = 'application/json';
                } else {
                    headers['Content-Type'] = undefined;
                }

                 var httpRequest = {
                    url: baseURL + request.url,
                    method: request.method || 'GET',
                    data: request.data||{},
                    headers: headers
                };
          	var x=this;
              /*return $http(httpRequest);*/
             return $http(httpRequest).then(function(response){
                 if(request.showNotifcation==undefined)
                    x.check(response)
                 return response;
              },function (response) {
                 x.check(response)
                 return $q.reject()
             })
      };
      this.check=function(response){

      		 if(response.status==500){
                Notification.info({message: $filter('translate')('ERROR500'), delay: 5000});
            }
            else if(response.status==401){
                Notification.info({message: $filter('translate')('ERROR401'), delay: 5000});
          }
      		else if(response.status!=200){
      			Notification.error({message: $filter('translate')('GENERAL_ERROR'), delay: 5000});
      		}
      };
}]) ;



// WEBPACK FOOTER //
// ./js/services/CallService.js